/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Не продавать и не передавать мою личную информацию",
      "Bumble Date",
      "Наши приложения",
      "О нас",
      "Карьера",
      "Связаться с нами",
      "Инвесторы",
      "Магазин",
      "Компания",
      "Скачать приложение",
      "Специальные возможности на Bumble",
      "Правила",
      "Настройки cookie",
      "Закон против современного рабства",
      "Положение о сборе персональных данных",
      "Политика конфиденциальности",
      "Условия обслуживания",
      "Правовые вопросы",
      "Политика конфиденциальности Вашингтона в отношении клиентских данных об исправности систем",
      "Просканируйте QR-код, чтобы скачать приложение Bumble",
      "Расторгнуть договор",
      "Закрыть меню",
      "Открыть меню",
      "Выбор языка",
      "Сноска",
      "Специальные возможности на Bumble",
      "Apple и Apple logo – товарные знаки компании Apple Inc.",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "Карьера",
      "Google Play является товарным знаком компании Google LLC.",
      "Правила",
      "Инвесторы",
      "Настройки cookie",
      "Закон о современном рабстве",
      "Положение о сборе персональных данных",
      "Конфиденциальность",
      "Сезонные дейтинг-советы",
      "Условия обслуживания",
      "Приложение",
      "Политика конфиденциальности Вашингтона в отношении клиентских данных об исправности систем",
      "О нас",
      "Амбассадоры",
      "Общайтесь с теми, кто разделяет ваши интересы.",
      "Заводите профессиональные связи и стройте карьеру",
      "Для поиска отношений любого уровня серьезности",
      "Блог",
      "Узнать больше",
      "Знакомства без границ в режиме Путешествий",
      "Date",
      "Функции",
      "Compliments",
      "Используйте Compliments, чтобы привлечь внимание вашей симпатии.",
      "Рядом",
      "Личная подборка совместимых профилей для вас, обновляемая ежедневно",
      "Режим Инкогнито",
      "Используйте режим Инкогнито, чтобы скрыть свой профиль от начальника, родственников или бывших.",
      "Мгновенная симпатия",
      "Начали общаться на мероприятии Bumble и не хотите останавливаться? Переходите в приложение и не сдерживайте себя!",
      "Opening Moves",
      "Выберите Opening Moves и ждите, пока ваша симпатия сама инициирует общение.",
      "Режим невидимки",
      "Хотите немного отдохнуть от дейтинга? Включите режим неведимки. Обещаем, мы вас дождёмся!",
      "SuperSwipe",
      "Понравился кто-то? Сообщите о своих чувствах с помощью SuperSwipe.",
      "Режим Путешествий",
      "Захватите что-нибудь вкусненькое в дьюти-фри, включите режим Путешествий и знакомьтесь в любой точке мира.",
      "Видеочат",
      "Созвонитесь с вашей симпатией по видео- или аудиосвязи, чтобы понять, готовы ли вы к реальной встрече.",
      "Веб-приложение",
      "Наслаждайтесь Bumble прямо из вашего браузера.",
      "Скачать приложение Bumble",
      "BFF",
      "Безопасность",
      "Истории",
      "Поддержка",
      "Магазин",
      "Основное",
      "Отправьте Compliments, чтобы привлечь внимание вашей симпатии.",
      "Compliments",
      "Функции, которые помогут создать настоящие, уважительные и глубокие отношения.",
      "Скройте свой профиль от начальника, родственников или бывших.",
      "Режим Инкогнито",
      "Хотите немного отдохнуть от дейтинга? Включите режим невидимки.",
      "Режим невидимки",
      "Понравился кто-то? Продемонстрируйте свои чувства.",
      "SuperSwipe",
      "Режим Date",
      "Захватите что-нибудь вкусненькое в дьюти-фри и знакомьтесь в любой точке мира.",
      "Режим Путешествий",
      "Подойдите максимально близко к атмосфере реальной встречи, не выходя из дома.",
      "Видеозвонки",
      "Наши лидеры транслируют ценности Bumble в своих сообществах по всей стране.",
      "Лидеры сообщества",
      "Функции, которые помогут вам найти близких вам по духу – и по интересам – людей.",
      "Организуйте групповую встречу или узнайте, что интересного происходит поблизости.",
      "Plans",
      "Загляните на BFF",
      "Все необходимые советы и вдохновение, чтобы помочь вам найти любовь и дружбу.",
      "Советы и истории, которые помогут найти настоящих друзей.",
      "Всё о дружбе",
      "О том, как пользователи Bumble по всему миру, от Токио до Торонто, находят любовь.",
      "Истории любви",
      "Как устроить идеальное свидание – в любое время, в любом вместе, с любым человеком.",
      "Сезонные дейтинг-советы",
      "Истории пользователей",
      "Читать дальше",
      "Bumble в {{social_network}}",
      "Обратная связь",
      "Войти",
      "(откроется в новом окне)",
      "Вопросы/ответы",
      "Политика использования файлов cookie",
      "Блог Bumble",
      "Карьера",
      "Чат",
      "Города",
      "Настройки cookie",
      "© 2006 – н.в. Bumble. Все права защищены.",
      "Уверенность на свиданиях – отчет",
      "Apple и логотип Apple являются товарными знаками компании Apple Inc.{{__EOL__}}Google Play является товарным знаком компании Google LLC.",
      "Скачать",
      "Facebook",
      "Подпишись на нас:",
      "Помощь",
      "Instagram",
      "Язык",
      "LinkedIn",
      "Bumble – часть Bumble Inc.",
      "Политика конфиденциальности",
      "Safety Centre",
      "Карта сайта",
      "Закон о современном рабстве",
      "Условия обслуживания",
      "Twitter"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "few": [
                  "дня",
                  "дней",
                  "дням",
                  "дня",
                  "днями",
                  "днях"
            ],
            "many": [
                  "дней",
                  "дней",
                  "дням",
                  "дней",
                  "днями",
                  "днях"
            ],
            "plural": [
                  "дня",
                  "дней",
                  "дням",
                  "дня",
                  "днями",
                  "днях"
            ],
            "singular": [
                  "день",
                  "дня",
                  "дню",
                  "день",
                  "днём",
                  "дне"
            ],
            "two": [
                  "дня",
                  "дней",
                  "дням",
                  "дня",
                  "днями",
                  "днях"
            ]
      },
      "hour": {
            "few": [
                  "часа",
                  "часов",
                  "часам",
                  "часа",
                  "часами",
                  "часах"
            ],
            "many": [
                  "часов",
                  "часов",
                  "часам",
                  "часов",
                  "часами",
                  "часах"
            ],
            "plural": [
                  "часа",
                  "часов",
                  "часам",
                  "часа",
                  "часами",
                  "часах"
            ],
            "singular": [
                  "час",
                  "часа",
                  "часу",
                  "час",
                  "часом",
                  "часе"
            ],
            "two": [
                  "часа",
                  "часов",
                  "часам",
                  "часа",
                  "часами",
                  "часах"
            ]
      },
      "minute": {
            "few": [
                  "минуты",
                  "минут",
                  "минутам",
                  "минуты",
                  "минутами",
                  "минутах"
            ],
            "many": [
                  "минут",
                  "минут",
                  "минутам",
                  "минут",
                  "минутами",
                  "минутах"
            ],
            "plural": [
                  "минуты",
                  "минут",
                  "минутам",
                  "минуты",
                  "минутами",
                  "минутах"
            ],
            "singular": [
                  "минута",
                  "минуты",
                  "минуте",
                  "минуту",
                  "минутой",
                  "минуте"
            ],
            "two": [
                  "минуты",
                  "минут",
                  "минутам",
                  "минуты",
                  "минутами",
                  "минутах"
            ]
      },
      "month": {
            "few": [
                  "месяца",
                  "месяцев",
                  "месяца",
                  "месяца",
                  "месяцами",
                  "месяцах"
            ],
            "many": [
                  "месяцев",
                  "месяцев",
                  "месяцев",
                  "месяцев",
                  "месяцами",
                  "месяцах"
            ],
            "plural": [
                  "месяца",
                  "месяцев",
                  "месяца",
                  "месяца",
                  "месяцами",
                  "месяцах"
            ],
            "singular": [
                  "месяц",
                  "месяца",
                  "месяц",
                  "месяц",
                  "месяцем",
                  "месяце"
            ],
            "two": [
                  "месяца",
                  "месяцев",
                  "месяца",
                  "месяца",
                  "месяцами",
                  "месяцах"
            ]
      },
      "second": {
            "few": [
                  "секунды",
                  "секунд",
                  "секундам",
                  "секунды",
                  "секундами",
                  "секундах"
            ],
            "many": [
                  "секунд",
                  "секунд",
                  "секундам",
                  "секунд",
                  "секундами",
                  "секундах"
            ],
            "plural": [
                  "секунды",
                  "секунд",
                  "секундам",
                  "секунды",
                  "секундами",
                  "секундах"
            ],
            "singular": [
                  "секунда",
                  "секунды",
                  "секунде",
                  "секунду",
                  "секундой",
                  "секунде"
            ],
            "two": [
                  "секунды",
                  "секунд",
                  "секундам",
                  "секунды",
                  "секундами",
                  "секундах"
            ]
      },
      "year": {
            "few": [
                  "года",
                  "лет",
                  "годам",
                  "года",
                  "годами",
                  "годах"
            ],
            "many": [
                  "лет",
                  "лет",
                  "годам",
                  "лет",
                  "годами",
                  "годах"
            ],
            "plural": [
                  "года",
                  "лет",
                  "годам",
                  "года",
                  "годами",
                  "годах"
            ],
            "singular": [
                  "год",
                  "года",
                  "году",
                  "год",
                  "годом",
                  "годе"
            ],
            "two": [
                  "года",
                  "лет",
                  "годам",
                  "года",
                  "годами",
                  "годах"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
